import IRawCaratech from "../models/product/caratech"
import { ITechFields } from "../ui/product-form/_reducers/form-id-state"

export const get_Only_DeclinableFromTechfields = (
  techFields: ITechFields,
  onlyKeepFilled = false
) =>
  Object.keys(techFields).reduce((acc, key) => {
    const valueIsFilled =
      Array.isArray(techFields[key].value) && techFields[key].value.length > 0
    if (techFields[key].isDeclinable && (!onlyKeepFilled || valueIsFilled)) {
      return { ...acc, [key]: techFields[key] }
    }
    return acc
  }, {} as ITechFields)

export const get_Not_DeclinableFromTechfields = (techFields: ITechFields) =>
  Object.keys(techFields).reduce((acc, key) => {
    if (!techFields[key].isDeclinable) {
      return { ...acc, [key]: techFields[key] }
    }
    return acc
  }, {} as ITechFields)

export const hasAtLeastSelectedOneDeclination = (techFields: ITechFields) =>
  Object.keys(techFields).some(
    (key) =>
      techFields[key].isDeclinable &&
      techFields[key].value !== undefined &&
      JSON.stringify(techFields[key].value) !== "[]" &&
      techFields[key].value !== -1 &&
      techFields[key].value !== "-1"
  )

export const caratechHasAnyValidValue = (caratech: IRawCaratech) =>
  (caratech.value &&
    caratech.value !== "-1" &&
    caratech.value !== -1 &&
    caratech.value !== "-") ||
  (caratech.valueCode &&
    caratech.valueCode !== "-1" &&
    (caratech.valueCode as unknown as number) !== -1 &&
    caratech.valueCode !== "-")

export const isValidCaratechValue = (value: any) =>
  value && value !== "-1" && value !== -1 && value !== "-"
